var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ThemeContext from './ThemeContext';
import './utils/focus-visible';
import { Global } from '@emotion/react';
/**
 * React Context Provider that returns a carina-based design theme.
 */
export var ThemeProvider = function (_a) {
    var theme = _a.theme, children = _a.children;
    return (_jsxs(ThemeContext.Provider, __assign({ value: theme }, { children: [_jsx(Global, { styles: {
                    '.js-focus-visible :focus:not(.focus-visible)': {
                        boxShadow: 'none',
                        outline: 'none'
                    }
                } }, void 0), children] }), void 0));
};
